import { Center } from "@chakra-ui/react";
import { PlayIcon } from "lucide-react";

export const PlayButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <Center
      bgColor="brand.1000"
      color="brand.100"
      borderRadius="full"
      p={4}
      onClick={onClick}
      cursor="pointer"
      _hover={{
        transform: "scale(1.2)",
      }}
      transition="all 0.3s ease"
      zIndex={10}
    >
      <PlayIcon size={48} />
    </Center>
  );
};
